export const GET_DIMENSIONS_WATCHER =
  "app/WidgetResultByDimensionAmbassador/GET_DIMENSIONS_WATCHER"
export const GET_DIMENSIONS_SUCCESS =
  "app/WidgetResultByDimensionAmbassador/GET_DIMENSIONS_SUCCESS"
export const GET_DIMENSIONS_FAILED =
  "app/WidgetResultByDimensionAmbassador/GET_DIMENSIONS_FAILED"
